// src/components/LineChart.js

import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp], // El mixin reactiveProp se encarga de actualizar el gráfico cuando 'chartData' cambia
  props: {
    // chartData es inyectado automáticamente por el mixin reactiveProp
    options: {
      type: Object,
      default: null
    }
  },
  mounted () {
    // this.chartData está disponible gracias al mixin
    this.renderChart(this.chartData, this.options)
  }
}